import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { ArrowLeft } from 'lucide-react';

import { useWizardState } from './useWizardState';
import { step1Schema, type Step1Input } from './schemas';
import { WizardShell } from './WizardShell';
import { cn } from '../../lib/cn';
import styles from './wizard.module.css';

const STEPS = ['ברוך הבא', 'פרטי העסק', 'לוקליזציה', 'סיכום'];

interface Props {
  defaultFullName: string;
}

export function Step1Welcome({ defaultFullName }: Props) {
  const data = useWizardState((s) => s.data);
  const patch = useWizardState((s) => s.patch);
  const next = useWizardState((s) => s.next);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Step1Input>({
    resolver: zodResolver(step1Schema),
    defaultValues: { full_name: data.full_name || defaultFullName },
  });

  const onSubmit = handleSubmit((values) => {
    patch({ full_name: values.full_name });
    next();
  });

  return (
    <WizardShell
      step={0}
      steps={STEPS}
      foot={
        <>
          <span />
          <button type="submit" form="step1-form" className={styles.btnPrimary}>
            המשך
            <ArrowLeft size={14} className="flip-rtl" />
          </button>
        </>
      }
    >
      <h3>ברוך הבא ל-FocusMode</h3>
      <p className={styles.help}>כמה פרטים בסיסיים ונתחיל</p>

      <form id="step1-form" className={styles.field} onSubmit={onSubmit} noValidate>
        <div className={styles.field}>
          <label htmlFor="step1-fullname">השם המלא שלך</label>
          <input
            id="step1-fullname"
            type="text"
            autoComplete="name"
            placeholder="לדוגמה: יואב רון"
            className={cn(styles.input, errors.full_name && styles.invalid)}
            {...register('full_name')}
          />
          {errors.full_name ? <p className={styles.error}>{errors.full_name.message}</p> : null}
        </div>
      </form>
    </WizardShell>
  );
}
